var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 5.438v-.444a1 1 0 00-1-1H7.753a1 1 0 01-.704-.29L5.622 2.29A1 1 0 004.918 2H3a1 1 0 00-1 1v8.552a1 1 0 00.296.71l.452.448a1 1 0 00.704.29h1.114m7.422-7.563H5.566a1 1 0 00-1 1V13m7.422-7.563H13a1 1 0 011 1V12a1 1 0 01-1 1H4.566",
    stroke: "#292929"
  })));
}
export default SvgIcnFolder;